import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { changeShoppingFlag } from '../../store';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

function PrivacyPolicy() {
    let navigate = useNavigate();

    return (
        <div style={{ width: "100%", padding: "0px 20px 65px", background: "#fff", minHeight: "100dvh", height: "100%", position: "relative" }}>
            <div
                style={{
                    color: '#000',
                    cursor: 'pointer',
                    position: 'absolute',
                    right: '15px',
                    top: '20px',
                    display: 'flex',
                    alignItems: 'center',
                }}
                onClick={() => {
                    navigate(-1)
                }}
            >
                <X style={{ width: '28px', height: '28px' }} />
            </div>
            <div style={{ fontSize: "15px", fontWeight: "500", color: "#000", paddingBottom: "30px", textAlign: "left", overflowY: "scroll", height: "100%" }}>
                <h2>개인정보 처리 방침</h2>

                1.목적<br />
                서울여의도청년회의소(이하 "회사")는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 관련 법규를 준수하며, 이용자의 개인정보를 보호하기 위해 최선을 다합니다.<br />
                본 개인정보 처리방침은 서울여의도청년회의소 게임 서비스(이하 "서비스") 이용과 관련하여 회사가 수집, 이용, 제공 및 관리하는 개인정보에 대한 내용을 담고 있습니다.<br />
                2.수집하는 개인정보 항목<br />
                필수 정보:<br />
                텔레그램 사용자 ID<br />
                게임 내 캐릭터 정보 (레벨, 재화, 아이템 등)<br />
                3.개인정보의 이용 목적<br />
                회원 관리: 텔레그램 계정 연동, 이용자 식별, 불량 이용자 제재<br />
                서비스 제공 및 개선: 게임 서비스 제공, 맞춤형 콘텐츠 제공, 신규 서비스 개발<br />
                고객 지원: 문의사항 처리<br />
                마케팅 활용: 게임 내 배너 광고 전송<br />
                4.개인정보의 제3자 제공<br />
                회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다.<br />
                법령에 의해 개인정보 제공이 요구되는 경우<br />
                5.개인정보의 보유 및 이용 기간<br />
                수집된 개인정보는 이용 목적 달성 시 즉시 파기합니다. 단, 다음의 경우에는 명시된 기간 동안 보관합니다.<br />
                법령에 따라 보관해야 하는 경우<br />
                이용자의 동의를 받은 경우<br />
                휴면 계정의 개인정보는 관련 법령에 따라 별도 분리 보관 후 파기합니다.<br />
                6.개인정보의 파기 절차 및 방법<br />
                파기 절차: 파기 사유 발생 시 개인정보보호책임자의 승인 후 파기합니다.<br />
                파기 방법:<br />
                전자적 파일 형태: 복구 불가능한 기술적 방법으로 영구 삭제<br />
                7.이용자의 권리 및 행사 방법<br />
                이용자는 언제든지 개인정보 열람, 정정, 삭제, 처리정지, 동의 철회를 요청할 수 있습니다.<br />
                권리 행사는 회사에 서면, 전화, 이메일 등으로 요청할 수 있으며, 회사는 지체 없이 조치합니다.<br />
                8.개인정보 보호책임자<br />
                개인정보 보호책임자: 포마컴퍼니<br />
                연락처: 1515-4220, saytodo1004@naver.com<br />
                9.개인정보 처리방침 변경<br />
                본 개인정보 처리방침은 법령, 정책 또는 회사의 필요에 따라 변경될 수 있습니다.<br />
            </div>
        </div>
    );
}

export default PrivacyPolicy;